import axios from "axios";
import { url } from "../../src/Values/constants";
import axiosHandler from "./axiosHandler";

export const sendNotification = async (
  organization_id: string,
  uid: string,
  title: string,
  description: string,
  data: any,
  authToken: any
) => {
  try {
    const apiData = {
      organization_id: organization_id,
      notifications: { [uid]: description },
      title,
      data,
    }

    const result = await axiosHandler.post(url + "/notification/sendNotifications", {
      headers: { "x-access-token": authToken },
      ...apiData,
    });
  } catch (err) {
    console.log("error", err);
  }
};
